import React from 'react';
import CustomTooltip from '../layout/Tooltip';

const WidgetActions = (props) => (
  <div>
    <CustomTooltip id="help" tooltip={'help'} placement={'bottom'}>
      <button
        type="button"
        className="btn btn-box-tool"
        data-widget="collapse"
        onClick={() => props.onInfoClick(props.infoIdText)}
      >
        <i className="fa fa-info-circle"></i>
      </button>
    </CustomTooltip>
    {!props.hideExpand && (
      <CustomTooltip id="resize" tooltip={'resize'} placement={'bottom'}>
        <button
          type="button"
          className="btn btn-box-tool"
          data-widget="remove"
          onClick={() => props.onExpandClick(props.expandIdText)}
        >
          <i className="fa fa-arrows-alt"></i>
        </button>
      </CustomTooltip>
    )}

    <CustomTooltip
      id="full screen"
      tooltip={'full screen'}
      placement={'bottom'}
    >
      <button
        type="button"
        className="btn btn-box-tool"
        data-widget="remove"
        onClick={() => props.onFullscreenClick(props.expandIdText)}
      >
        <i className="fa fa-expand"></i>
      </button>
    </CustomTooltip>
  </div>
);

export default WidgetActions;
